import * as React from 'react';
const ImpetigineIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M100 121.17c-32.39 0-44.04-23.08-44.04-23.08C69.31 80.99 88.35 72.45 100 84.41c11.65-11.97 30.68-3.42 44.04 13.68 0 0-11.65 23.08-44.04 23.08"
      className="prefix__cls-2"
    />
    <path
      d="M144.04 98.09S120.9 102.2 100 102.2s-44.04-4.11-44.04-4.11"
      className="prefix__cls-2"
    />
    <circle cx={63.59} cy={119.05} r={3.37} className="prefix__cls-1" />
    <circle cx={90.65} cy={130.21} r={3.37} className="prefix__cls-1" />
    <circle cx={69.51} cy={125.12} r={4.57} className="prefix__cls-1" />
    <circle cx={78.17} cy={126.27} r={2.25} className="prefix__cls-1" />
  </svg>
);
export default ImpetigineIcon;
